<template>
    <v-card hover raised>
        <v-card-title primary-title>
            <h3 class="headline mb-0">Kanban</h3>
            <v-spacer></v-spacer>
            <slot name="opciones"></slot>
        </v-card-title>
        <v-container fluid grid-list-sm justify-center class="contenedor">
            <v-layout>
                <v-flex xs12 v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-flex>
                <template v-for="e in estados" v-if="!loading">
                    <v-flex>
                        <v-card hover raised>
                            <v-toolbar :color="e.color" dark dense flat>
                                <v-toolbar-title>{{ e.desig }}</v-toolbar-title>
                            </v-toolbar>
                            <v-list v-if="presup[e.id]" class="lista">
                                <template v-for="p in presup[e.id]">
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Presup <router-link exact :to="'/presupuesto/' + p.presupuesto.id">{{ p.presupuesto.id }}</router-link>
                                                | Item: <router-link exact :to="'/presupuesto/' + p.presupuesto.id + '/'+ p.item_tipo.cod +'/edit/' +  p.id">{{ p.id }}</router-link>
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </template>
                            </v-list>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
    import mixinPresupuesto from '../../mixins/presupuesto';

    export default {
        name: "Kanban",
        mixins: [mixinPresupuesto],
        data() {
            return {
                estados: [],
                presup: [],
                loading: false,
            }
        },
        mounted() {
            this.loading = true;
            this.estadosListado(r => {
                this.estados = r;
                this.presupuestoMiosEstado(r => {
                    this.presup = r;
                    this.loading = false
                }, err => {
                    console.error(err);
                    this.loading = false
                })
            }, err => {
                console.log(err);
                this.loading = false
            })
        }
    }
</script>

<style scoped>
    .contenedor {
        overflow: auto;
    }

    .lista {
        max-height: 200px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/Kanban.vue